import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomComponentAreaCaseBySubmission from "src/components/manufacturer/customComponentAreaCaseBySubmission";
import Top10Payors from "src/components/manufacturer/top10Payors";

import useFetch from "src/hooks/useFetch";
import {AuthContext} from "../../context/authContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { GeographicalStatisticsObject, StatisticsApiResponse } from "./types";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import { MANUFACTURER_DEFAULT_END_DATE, MANUFACTURER_DEFAULT_START_DATE } from "src/constants/manufacturer";



const Manufacturer: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const insuranceName:string | null = params.get('insurance_name');

  const [queryParams, changeQueryParams] = useState({
    start_date: searchParams.get("start_date") || MANUFACTURER_DEFAULT_START_DATE,
    end_date: searchParams.get("end_date") || MANUFACTURER_DEFAULT_END_DATE,
    period: searchParams.get('period') || "day",
    filter_type: searchParams.get("filter") || "",
    type: "index",
    soc_value:searchParams.get("soc_value") || "",
    drug_id:searchParams.get("drug_id") || "",
    user_id: searchParams.get("user_id") || (userData && userData.ref_type === "rep" ? userData.id.toString() : "") || "",
    insurance_name:insuranceName,
    case_filter: "",
    search_str: "",
  });




  const { data: statisticsData, error: statisticsError, mutate: getStatsData } = 
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData || statisticsError) {
      hideLoader();
      if (statisticsData && statisticsData.code === 200)
        showToast([statisticsData.message], ToastTypes.SUCCESS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData, statisticsError]);

  useEffect(() => {
    if(insuranceName){
      const updatedQueries = {
        ...queryParams,
        insurance_name:insuranceName
        
      } 
      changeQueryParams(updatedQueries)
      getStatsData({}, {}, updatedQueries);
    }
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insuranceName]);

  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: MANUFACTURER_DEFAULT_START_DATE,
        end_date: MANUFACTURER_DEFAULT_END_DATE,
        period: "",
        filter_type: "",
        type: "index",
        soc_value:"",
        drug_id:"",
        user_id: "",
        insurance_name:"",
        case_filter: "",
        search_str: "",
      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,
      
    } 
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }




  return (
    <div className="container-fluid pt-4 overflow-x-hidden overflow-y-auto bg-white d-flex flex-column flex-fill">
      <AuthMaunfacturerSubHeader />

      <CaseFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />

      {statisticsData && statisticsData.data && (
        <CaseVolume 
          queryParams={queryParams} StatisticsObjectType={statisticsData.data} 
          getStatisticsData={getStatisticsData} buttonShows={true}
        />
      )}
    
      {statisticsData && <Top10Payors StatisticsObjectType={statisticsData.data}/>}

      {statisticsData && (
        <CustomComponentAreaCaseBySubmission queryParams={queryParams} StatisticsObjectType={statisticsData.data} />
      )}

      {statisticsData?.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData?.data
              .geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}
      <FooterText footerType="black" />
    </div>
  );
};

export default Manufacturer;
